import { createFileRoute } from "@tanstack/react-router"

import { propertyTypesQuery } from "@/api/query/propertyTypes"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_header/templates/new/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { permission: { flag: "iot:template::create", fallbackRoute: { to: "/templates" } } })
  },
  loader: ({ context: { queryClient } }) => {
    queryClient.query({ ...propertyTypesQuery, staleTime: "static" })
  },
  head: () => ({
    meta: [
      {
        title: "New Template | Arduino Cloud"
      }
    ]
  })
})
